import * as React from 'react';

import { BackButton } from './BackButton';
import { useStyles } from './styles';
import { useStepper } from '../../context';

export type HeaderProps = {
  title: string;
  description?: React.ReactNode;
};

function Header({ title, description }: HeaderProps) {
  const { currentStep, stepsLength } = useStepper();
  const classes = useStyles();

  return (
    <header className={classes.root}>
      <BackButton />
      <span className={classes.counter} aria-valuenow={currentStep}>
        Passo {currentStep} de {stepsLength}
      </span>
      <h2 id='step-title' className={classes.title}>
        {title}
      </h2>
      {description && <p className={classes.description}>{description}</p>}
    </header>
  );
}

export { Header };
